import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import { UserCompaniesProvider } from '@/contexts/UserCompaniesContext';

// Page components
import Dashboard from '@/pages/Dashboard';
import Settings from '@/pages/Settings';
import ApiKeys from '@/pages/ApiKeys';
import FeedViewer from '@/pages/FeedViewer';

/**
 * Props passed from shell via Module Federation.
 * Must match SharedAppData interface in shell's ModuleFederationLoader.
 */
interface AppProps {
  userCompanies?: Array<{ id: string; name: string; color?: string }>;
  // Future shared data (keep in sync with shell's SharedAppData):
  // currentCompanyId?: string;
  // userPreferences?: { theme?: string; locale?: string };
  // featureFlags?: Record<string, boolean>;
}

function App({ userCompanies }: AppProps) {
  return (
    <UserCompaniesProvider initialCompanies={userCompanies}>
      <div className="min-h-screen text-foreground">
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="feed-viewer" element={<FeedViewer />} />
          <Route path="api-keys" element={<ApiKeys />} />
          <Route path="settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
      </div>
    </UserCompaniesProvider>
  );
}

export default App;
